import { onPointerDownRoomDimensions } from '@/Engine/eventHandlers/roomDimensionChanging';
import {
    getBoxIntersections,
    getIntersection,
    getShelfIntersections,
    getSizingBoxesIntersection,
} from '@/Engine/intersections';
import { $ } from '@/Engine/state';
import { useUIOnlyStore } from '@/Store/storeUI';

export const onDownHandler = () => {
    if (useUIOnlyStore().mode === 1) {
        onPointerDownRoomDimensions(getSizingBoxesIntersection(), getIntersection([ $.room.ceilRaycastPlane ]));
    }
    $.wallPointer = null;
    $.floorPointer = null;
    $.mouseDown = true;
    let checkDragging = false;
    const intersections = [ ...getBoxIntersections(), ...getShelfIntersections() ];
    intersections.forEach((intersection) => {
        if (intersection.object.userData.parent === $.selectionBox.target ||
            $.selectionBox.targetGroup.some((item)=>item.uuid === intersection.object.userData.parent.uuid))
            checkDragging = true;
    });

    intersections.forEach((intersection) => {
        if (intersection.object.userData.parent === $.selectionBoxForBox.target)
            checkDragging = true;
    });

    if (!checkDragging) {
        $.app.controls.enabled = true;
        $.dragging = false;
    } else {
        $.app.controls.enabled = false;
        $.dragging = true;
    }

    $.render();
};
